module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"value":"Value"},"fr":{"value":"Valeur"}}')
  delete Component.options._Ctor
}
